/**
 * Labstep
 *
 * @module components/OrganizationSAML/Form/fields
 * @desc OrganizationSAML fields
 */

import type { FieldWithoutActionProps } from 'labstep-web/core/Form/Reusable/types';
import rules, {
  type OrganizationSAMLRules,
} from 'labstep-web/services/validation/rules';

export const getFormField = (
  fieldType: any,
  name: keyof OrganizationSAMLRules,
  fieldLabel: string,
  placeholder?: string,
): FieldWithoutActionProps => ({
  fieldType,
  name,
  fieldLabel,
  placeholder,
  validation: rules.organization_saml[name],
  fieldExplainer: placeholder,
});
